import { render } from "./SkiSchools.vue?vue&type=template&id=7ec06448&scoped=true"
import script from "./SkiSchools.vue?vue&type=script&lang=js"
export * from "./SkiSchools.vue?vue&type=script&lang=js"

import "./SkiSchools.vue?vue&type=style&index=0&id=7ec06448&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec06448"]])

export default __exports__